import React from 'react';
import {
  CloseRounded as CloseRoundedIcon,
  MenuRounded as MenuRoundedIcon,
} from '@mui/icons-material';
import { Box, ButtonBase, Typography } from '@mui/material';
import { GUARANTEES_MENU_LABEL } from '../constants.ts';
import { guaranteesLayoutStyles } from '../styles.ts';
import type { IMenuTriggerProps } from './types.ts';

const MenuTrigger: React.FC<IMenuTriggerProps> = ({ isOpen, onClick }) => {
  return (
    <ButtonBase onClick={onClick} sx={guaranteesLayoutStyles.menuTrigger}>
      <Typography component="span" sx={guaranteesLayoutStyles.menuTriggerText}>
        {GUARANTEES_MENU_LABEL}
      </Typography>

      <Box component="span" sx={guaranteesLayoutStyles.menuTriggerIconWrap}>
        {isOpen ? (
          <CloseRoundedIcon sx={guaranteesLayoutStyles.menuTriggerIcon} />
        ) : (
          <MenuRoundedIcon sx={guaranteesLayoutStyles.menuTriggerIcon} />
        )}
      </Box>
    </ButtonBase>
  );
};

export default MenuTrigger;
